<template>
  <div class="sustainability-health-and-safety">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <img
          class="row-1-top-img desktop"
          src="../../assets/img/sustainability/health_and_safety/img_left.jpg"
        >
        <div class="text-group">
          <h3 class="text-accent">{{ $t('sustainability-health-and-safety-1') }}</h3>
          <h1>{{ $t('sustainability-health-and-safety-2') }}</h1>
          <h2>{{ $t('sustainability-health-and-safety-3') }}</h2>
          <img
            class="row-1-top-img mobile"
            src="../../assets/img/sustainability/health_and_safety/img_left.jpg"
          >
          <p v-html="$t('sustainability-health-and-safety-4')"></p>
          <p v-html="$t('sustainability-health-and-safety-5')"></p>
          <p v-html="$t('sustainability-health-and-safety-6')"></p>
          <p v-html="$t('sustainability-health-and-safety-7')"></p>
          <p v-html="$t('sustainability-health-and-safety-8')"></p>
        </div>
      </div>
      <div class="img-and-btn">
        <Carousel :imgs="imgs"/>
        <!-- <img src="../../assets/img/sustainability/health_and_safety/img_right.jpg"> -->
        <!-- <div class="btn-arrow" @click="toggleScroll()">
          <span class="kcm toggle-down">C</span>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from './Carousel';
export default {
  data() {
    return {
      imgs: [
        require('../../assets/img/sustainability/health_and_safety/img_right.jpg'),
        require('../../assets/img/sustainability/health_and_safety/2.jpg'),
        require('../../assets/img/sustainability/health_and_safety/3.jpg'),
        require('../../assets/img/sustainability/health_and_safety/4.jpg'),
        require('../../assets/img/sustainability/health_and_safety/5.jpg'),
        require('../../assets/img/sustainability/health_and_safety/6.jpg'),
      ]
    };
  },
  components: {
    Carousel
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName('btn-arrow')[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sustainability-health-and-safety {
  position: relative;
}
.mobile {
  display: none;
}

@media screen and (max-width: 1000px) {
  .row-1 {
    padding: $sidesPadding1280 0 0;
    flex-direction: column;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .img-and-text {
      width: 100%;
      .row-1-top-img {
        width: 100%;
      }
      .text-group {
        margin: 0;
        padding: 0 $sidesPadding1280;
      }
    }
    .img-and-btn {
      width: 100%;
      padding: 0;
      .carousel {
        height: 50vw;
      }
      .carousel,
      img {
        width: 100%;
        margin: 0;
      }
      .btn-arrow {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .row-1 {
    padding: $sidesPadding600 0 0;
    .img-and-text {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }
}
</style>
